import {
  PROBATE_ESTATE_ITEM_TYPES,
  ProbateEstate,
} from 'lib/models/probate-estate'

import Part from '../components/part'
import { QUESTIONNAIRE_SECTIONS } from '../constants'
import useEstateItems from '../estate/use-estate-items'

import UtilityProviders from './utility-providers'
import FuneralBill from './funeral-bill'
import OtherBills from './other-bills'

type HandleSave = (event: { name: string; value: unknown }) => void

type Props = {
  probateEstate: ProbateEstate
  saveProbateEstateField: HandleSave
}

const DebtsAndLiabilities = ({
  probateEstate,
  saveProbateEstateField,
}: Props) => {
  // utilities and other bills share an itemType; a utilityType is the only
  // thing that tells them apart
  const { forType } = useEstateItems({ probateEstateId: probateEstate.id })
  const debts = forType(PROBATE_ESTATE_ITEM_TYPES.UTILITY_OR_OTHER_DEBT)
  const utilityProviders = {
    ...debts,
    items: debts.items.filter((item) => item.attributes.utilityType),
  }
  const otherBills = {
    ...debts,
    items: debts.items.filter((item) => !item.attributes.utilityType),
  }

  const { attributes } = probateEstate

  return (
    <Part
      id={QUESTIONNAIRE_SECTIONS.DEBTS_AND_LIABILITIES.id}
      heading={QUESTIONNAIRE_SECTIONS.DEBTS_AND_LIABILITIES.heading}
      description="To understand what the estate owes or is responsible for."
    >
      <UtilityProviders
        collection={utilityProviders}
        sectionActive={attributes.utilityProvidersSectionActive}
        saveProbateEstateField={saveProbateEstateField}
      />
      <FuneralBill
        probateEstate={probateEstate}
        saveProbateEstateField={saveProbateEstateField}
      />
      <OtherBills
        collection={otherBills}
        sectionActive={attributes.otherBillsSectionActive}
        saveProbateEstateField={saveProbateEstateField}
      />
    </Part>
  )
}

export default DebtsAndLiabilities
